import { render, staticRenderFns } from "./MarketplaceLeadsTable.vue?vue&type=template&id=5a78d565&scoped=true&"
import script from "./MarketplaceLeadsTable.vue?vue&type=script&lang=js&"
export * from "./MarketplaceLeadsTable.vue?vue&type=script&lang=js&"
import style0 from "./MarketplaceLeadsTable.vue?vue&type=style&index=0&id=5a78d565&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a78d565",
  null
  
)

export default component.exports